module.exports = __webpack_public_path__ + "img/99ne.2c258a07.svg";